import * as React from 'react'

export const SVG_VideoCapture = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52">
        <g fill="none" fillRule="evenodd">
            <g fill="#42B6E7" fillRule="nonzero" stroke="#42B6E7" strokeWidth=".5">
                <g>
                    <path
                        d="M31.668 1.784c-.206-.121-.46-.126-.671-.012l-7.342 3.976V3.362C23.653 1.506 22.136.002 20.265 0H3.39C1.519.002.002 1.506 0 3.362v13.276c.002 1.856 1.519 3.36 3.39 3.362h16.875c1.871-.002 3.388-1.506 3.39-3.362v-2.343l7.342 3.977c.21.113.465.109.67-.012.207-.122.333-.341.333-.579V2.362c0-.237-.126-.457-.332-.578zm-9.37 14.854c0 1.114-.91 2.016-2.034 2.017H3.39c-1.123 0-2.033-.903-2.034-2.017V3.362c.001-1.113.91-2.016 2.034-2.017h16.875c1.122.001 2.032.904 2.034 2.017v13.276zm8.346-.09l-6.99-3.785V7.28l6.99-3.785v13.053z"
                        transform="translate(10 16)"
                    />
                </g>
            </g>
        </g>
    </svg>
)
